/* eslint-disable react/no-unescaped-entities */
import Layout from "@/components/elements/Layout";
import ApplyJob from "@/components/form/ApplyJob";
import { getCareerDetail, getCareerOther } from "@/services/api/Career";
import { cleanHTML } from "@/utils/content";
import slugify from "@/utils/slugify";
import Image from "next/legacy/image";
import Link from "next/link";
import ScrollspyNav from "react-scrollspy-nav";

const CareerDetail = ({ career, others }) => {
  return (
    <Layout title={`${career?.job_title || 'Career Opportunity'} | Careers | Lucidity Insights`} description={career?.short_description || 'Join our team at Lucidity Insights'}>
      <div className='relative'>
        <div className='relative aspect-[16/9] lg:aspect-[21/4] overflow-hidden w-full'>
          <Image
            src={career.thumbnail_url}
            width={1920}
            height={1080}
            alt=''
            className='object-cover w-full h-full'
          />
          <span className='absolute inset-0 w-full h-full bg-gradient-to-t from-dark-2 via-dark-2/90 to-dark-2/60'></span>
          <div className='absolute w-full bottom-8'>
            <div className='flex flex-col max-w-6xl px-4 mx-auto space-y-2 text-white 2xl:max-w-7xl'>
              <h1 className='text-4xl font-bold lg:text-6xl'>
                {career.job_title}
              </h1>
              <span className='font-medium opacity-50'>
                {career.employee_type} &bull; {career.workplace_type}
              </span>
            </div>
          </div>
        </div>
        <div className='max-w-6xl px-4 pt-10 pb-16 mx-auto lg:pb-24 lg:pt-16 lg:space-x-20 lg:flex 2xl:max-w-7xl'>
          <div className='flex-1 -mt-8 prose text-white max-w-none prose-p:opacity-60 prose-ul:opacity-60 prose-headings:text-white'>
            <div id='about'>
              <h3>About Lucidity Insights</h3>
              <p>
                Lucidity Insights or www.LucidityInsights.com is a business data
                & insights streaming platform specializing in developing
                world-class investigative special reports and digital content
                told across various multimedia channels. We believe in the
                democratization of quality data and insights on the Middle East
                and Africa’s tech and entrepreneurial ecosystem, so we can help
                level-up every decision made by an entrepreneur or investor in
                the region. Access to data can make or break a strategy or a
                business, and we’re here to help you get the quality level
                insights Fortune 500 companies pay for.
              </p>
              <p>
                Think: Netflix meets Pitchbook and has a baby with Masterclass
                in order to provide top data and insights for learning about the
                entrepreneurial and tech ecosystems of the Middle East and
                Africa region. You can binge as much content as you want, so
                long as you’re learning something. And at Lucidity Insights,
                we’re all about choice. We believe that you, as the consumer,
                get to decide how you want to digest your data, for your optimal
                learning. Is it by downloading a comprehensive 60-page report?
                Maybe that’s too long, and you’d prefer bite-sized articles that
                tackle each subject one by one. How about short 1min videos?
                Perhaps you prefer a 10-15min documentary style video equipped
                with interviews… or maybe you’re old-school and just want to
                look at the charts and infographics to glean whatever data you
                want for yourself. Whatever way you want to consume it, we got
                it.
              </p>
              <p>
                And at Lucidity Insights, we’re all about choice. We believe
                that you, as the consumer, get to decide how you want to digest
                your data, for your optimal learning. Is it by downloading a
                comprehensive 60-page report? Maybe that’s too long, and you’d
                prefer bite-sized articles that tackle each subject one by one.
                How about short 1min videos? Perhaps you prefer a 10-15min
                documentary style video equipped with interviews… or maybe
                you’re old-school and just want to look at the charts and
                infographics to glean whatever data you want for yourself.
                Whatever way you want to consume it, we got it.
              </p>
            </div>
            <div id='job-desc'>
              <h3>Job Description</h3>
              {cleanHTML(career.job_descriptions)}
            </div>
            <div id='responsibilities'>
              <h3>Responsibilities</h3>
              {cleanHTML(career.responsibilities)}
            </div>
            <div id='skills'>
              <h3>Skills and Competencies</h3>
              {cleanHTML(career.skills_and_competencies)}
            </div>
            <p>
              If you are a talented and experienced {career.job_title} with a
              passion for data-driven journalism and a keen interest in the
              industries we cover, we would love to hear from you. Apply today
              and join our team of dedicated and passionate professionals!
            </p>
          </div>
          <div className='lg:sticky lg:w-[250px] h-full lg:top-32 space-y-12 mt-6 lg:mt-0 lg:space-y-10'>
            <ApplyJob career={career} />
            <div className='hidden lg:block'>
              <ScrollspyNav
                scrollTargetIds={[
                  "about",
                  "job-desc",
                  "responsibilities",
                  "skills",
                ]}
                offset={87}
                activeNavClass='!opacity-100'
                scrollDuration='1000'
                headerBackground='true'
              >
                <span className='block pb-3 mb-3 font-bold text-white border-b border-white/10'>
                  What’s On Page
                </span>
                <div className='flex flex-col space-y-3.5 text-sm font-medium text-white'>
                  <a
                    href='#about'
                    className='transition-colors duration-300 opacity-30'
                  >
                    About Lucidity Insights
                  </a>
                  <a
                    href='#job-desc'
                    className='transition-colors duration-300 opacity-30'
                  >
                    Job Descriptions
                  </a>
                  <a
                    href='#responsibilities'
                    className='transition-colors duration-300 opacity-30'
                  >
                    Responsibilities
                  </a>
                  <a
                    href='#skills'
                    className='transition-colors duration-300 opacity-30'
                  >
                    Skills and Competencies
                  </a>
                </div>
              </ScrollspyNav>
            </div>
            {others.length > 0 && (
              <div>
                <span className='block pb-3 mb-3 font-bold text-white border-b border-white/10'>
                  Other Job Listings
                </span>
                <div className='flex flex-col space-y-5 font-medium text-white'>
                  {others.map((other) => (
                    <Link legacyBehavior
                      key={other.uuid}
                      href={`/careers/${slugify(other.job_title)}-${other.id}`}
                    >
                      <a className='flex flex-col space-y-1'>
                        <span className='text-base font-medium lg:text-sm'>
                          {other.job_title}
                        </span>
                        <span className='text-sm opacity-50 lg:text-xs'>
                          {other.employee_type} &bull; {other.workplace_type}
                        </span>
                      </a>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CareerDetail;

export async function getServerSideProps({ params }) {
  const { slug } = params;
  const id = slug.split("-").pop();
  const careerData = await getCareerDetail(id);
  const careerDataOther = await getCareerOther(id);

  const career = careerData?.data || null;
  const others = careerDataOther?.data || [];

  if (!career || !career.is_open) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      career,
      others,
      id,
    },
  };
}
